import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'scrolltofixed';
import 'slick-carousel';

import OneProductForm from '@/modules/module-oneProductForm';
import OneZoom from '@/modules/module-oneZoom';
import OneDrawer from '@/modules/module-oneDrawer';
import OneTabSystem from '@/modules/module-oneTabSystem';
import OneVideo from '@/modules/module-oneVideo';
import OneRecentlyViewed from '@/modules/module-oneRecentlyViewed';
import OneMarketing from '@/modules/module-oneMarketing';

import '../../styles/modules/oneSizeChart.scss';
import { PUB_SUB_EVENTS, subscribe, publish } from '@/lib/pubsub';

export default Backbone.View.extend({

    initialize: function (opts) {

        console.log('init PDP');

        var self = this

        // $content is <body>
        self.$content = self.$el;
        self.templateSuffix = self.$content.data('tempsuffix');
        self.$detailContainer = self.$content.find('.product-detail-container');

        self.$media = self.$content.find('.product-media');
        self.$mainImage = self.$media.find('#ProductMediaImages');
        self.$thumbImage = self.$media.find('#ProductMediaThumbs');
        self.$mediaSlider = self.$mainImage.find('.images-wrapper');
        self.$thumbSlider = self.$thumbImage.find('.images-wrapper');

        self.$productCore = self.$content.find('.product-core');
        self.$socialIcons = self.$productCore.find('.one-social');
        self.isGiftCard = self.$detailContainer.hasClass('gift-card');
        self.productQty = self.$content.find('.product-qty-container');
        self.productCrossSell = self.$content.find('.block-cross-sell');

        self.$shippingCountdownBanner = self.$content.find('.product-core-block.block-shipping-countdown');
        self.$recentlyViewed = self.$content.find('.recently-viewed .items');

        // Features
        self.enableMiniCore = false;
        self.isScrollingLayout = self.$content.data('layout') == 'scrolling' ? true : false;
        self.isScrollingGrid = self.$content.hasClass('scrolling-grid');
        self.isSliderLayout = self.$content.data('layout') == 'slider' ? true : false;
        self.isQuickshopLayout = self.$content.data('layout') == 'quickshop' ? true : false;

        // Data
        self.linkedCollectionData = this.el.querySelector('.linked-collection-json') ? JSON.parse(this.el.querySelector('.linked-collection-json').textContent) : null;

        if (ORW.enableGTM) {
            ORW.marketing = ORW.marketing || new OneMarketing;
        }

        self.productCore();
        self.initPrice();

        if (!self.isGiftCard && !self.isQuickshopLayout) {
            self.productMedia();
        }

        if (!self.isQuickshopLayout) {
            // self.social();
            self.initPostATCModal();
            self.initReviews();

            if (ORW.enableGTM) {
                ORW.marketing.viewItem(self.$productCore);
            }
        } else {
            self.productCoreSwatchSlider();
        }

        if (!self.isGiftCard && !self.isQuickshopLayout) {
            self.zoom();
            self.video();
            self.sizeChart();
            self.accordionsAndTabs();
            self.recentlyViewed();
        }

        if (self.templateSuffix === 'education') {
            self.initEducationForm();
        } else {
            self.productFormInstance = OneProductForm.init({
                el: self.el.querySelector('form.add-to-cart-form'),
                preSelect: self.isQuickshopLayout,
                updateURL: !self.isQuickshopLayout,
            });
        }

        if (self.$shippingCountdownBanner.length > 0) {
            self.shippingCountdownBanner();
        }

    },

    events: {
    },

    productMedia: function () {
        var self = this;
        var videoAutoplayEnabled = self.$media.data('video-autoplay') === true || self.$media.data('video-autoplay') === 'true';

        var events = {
            'click .image-thumbnail': function (e) {
                e.preventDefault();
                var $curr = $(e.currentTarget);
                var index = $curr.data('index') - 1;
                var isVideoThumbnail = $curr.find('.video-thumbnail').length > 0 || $curr.hasClass('media-video');

                // If clicking on active video thumbnail and autoplay is disabled, toggle play/pause
                if ($curr.hasClass('active') && isVideoThumbnail && !videoAutoplayEnabled) {
                    var $activeSlide = self.$mainImage.find('.slick-active');
                    if ($activeSlide.length) {
                        var $videoWrapper = $activeSlide.find('.video-wrapper');
                        if ($videoWrapper.length) {
                            var $video = $videoWrapper.find('video')[0];
                            var $videoCtl = $videoWrapper.find('.video-ctl');
                            var $thumbnailCtl = $curr.find('.video-ctl-thumbnail');

                            if ($video) {
                                if ($video.paused) {
                                    $video.play();
                                } else {
                                    $video.pause();
                                }
                            }
                        }
                    }
                    return;
                }

                // Otherwise, navigate to the thumbnail
                self.$thumbImage.find('.image-thumbnail').removeClass('active');
                $curr.addClass('active');
                if (self.$media.hasClass('initialized')) {
                    self.$mediaSlider.slick('slickGoTo', index);
                }
            },
            'click .image-slide.media-video .video-wrapper': function (e) {
                // Make entire video wrapper clickable for play/pause
                // Skip if clicking the video control button (it has its own handler)
                if ($(e.target).hasClass('video-ctl') || $(e.target).closest('.video-ctl').length) {
                    return;
                }

                e.preventDefault();
                e.stopPropagation();

                var $videoWrapper = $(e.currentTarget);
                var $video = $videoWrapper.find('video')[0];
                var $videoCtl = $videoWrapper.find('.video-ctl');
                var $slide = $videoWrapper.closest('.image-slide');
                var slideIndex = $slide.data('index');
                var $thumbnailCtl = self.$thumbImage.find('.image-thumbnail[data-index=' + slideIndex + '] .video-ctl-thumbnail');

                if ($video) {
                    if ($video.paused) {
                        $video.play();
                        $videoCtl.removeClass('paused').addClass('playing');
                        $thumbnailCtl.removeClass('paused').addClass('playing');
                    } else {
                        $video.pause();
                        $videoCtl.removeClass('playing').addClass('paused');
                        $thumbnailCtl.removeClass('playing').addClass('paused');
                    }
                }
            }
        }
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();

        self.$mediaSlider.on('init', function (event, slick, direction) {
            self.$media.addClass('initialized');
            $(window).resize();
        });
        self.$mediaSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            self.$thumbImage.find('.image-thumbnail').removeClass('active');
            var $nextThumbnail = self.$thumbImage.find('.image-thumbnail[data-index=' + (nextSlide + 1) + ']');
            $nextThumbnail.addClass('active');

            // Pause current video
            var $currentSlide = $(slick.$slides[currentSlide]);
            var $currentVideoWrapper = $currentSlide.find('.video-wrapper');
            if ($currentVideoWrapper.length) {
                var $currentVideo = $currentVideoWrapper.find('video')[0];
                if ($currentVideo && !$currentVideo.paused) {
                    $currentVideo.pause(); // Button states will sync automatically via OneVideo module
                }
            }

            // Auto-play next video when slide becomes active (if autoplay setting is enabled)
            if (videoAutoplayEnabled) {
                setTimeout(function () {
                    var $nextSlide = $(slick.$slides[nextSlide]);
                    var $videoWrapper = $nextSlide.find('.video-wrapper');
                    if ($videoWrapper.length) {
                        var $video = $videoWrapper.find('video')[0];
                        if ($video && $video.paused) {
                            $video.play(); // Button states will sync automatically via OneVideo module
                        }
                    }
                }, 650);
            }
        })
        self.$mediaSlider.slick({
            dots: true,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            arrows: false,
            rows: 0,
        });

        // if (self.$thumbSlider.find('.image-thumbnail').length > 5) {
        //     self.$thumbSlider.slick({
        //         dots: false,
        //         infinite: false,
        //         speed: 600,
        //         slidesToShow: 5,
        //         arrows: true,
        //         rows: 1,
        //         variableWidth: true,
        //     })
        // }

        // Main Slick slider
        const $imageSlider = this.$el.find('.product-media-images .images-wrapper');
        const imageMain = $imageSlider[0]; // JS element object same as $imageSlider[0]
        // Thumb Images
        const imageThumbs = this.el.querySelector('.product-media-thumbnails .images-wrapper');

        // Check if image elements have more than one value. If not, don't initialize
        const imageVariantValues = new Set(
            [...imageThumbs.querySelectorAll('[data-variant-option-value]')]
                .map(el => el.dataset.variantOptionValue)
                .filter(Boolean) // Remove empty values
        );
        if (imageVariantValues.size <= 1) return;

        subscribe(PUB_SUB_EVENTS.variantOptionsChange, (options) => {

            const filterSelector = options.map(option => `[data-variant-option-value="${ORW.utilities.handleize(option)}"]`).join(',');

            // Maybe no option selected yet
            if (!filterSelector) return

            // Update Main Slick slider (need to do unfilter first to bring back the filtered out slides from previous filter)
            $imageSlider.slick('slickUnfilter');
            const preFilterCheck_main = imageMain.querySelectorAll(filterSelector);
            if (preFilterCheck_main.length === 0) return
            $imageSlider.slick('slickFilter', filterSelector);

            // Update Thumb Images
            const preFilterCheck_thumbs = imageThumbs.querySelectorAll(filterSelector);
            if (preFilterCheck_thumbs === 0) return
            imageThumbs.querySelectorAll('.image-thumbnail').forEach(el => {
                el.hidden = true;
            });
            preFilterCheck_thumbs.forEach(el => {
                el.hidden = false
            });
        });
    },

    initPrice: function () {
        const atc_btn = document.getElementById('AddToCart');
        const sticky_atc = document.getElementById('sticky_atc');
        const priceElem = this.el.querySelector('.product-detail-container .price-box');
        const hasDiscountLink = priceElem.dataset.hasDiscountLink === 'true';
        let discountLink;

        if (hasDiscountLink && priceElem.querySelector('.discount-login-link')) {
            discountLink = priceElem.querySelector('.discount-login-link').cloneNode(true);
        }

        subscribe(PUB_SUB_EVENTS.variantChange, (variant) => {
            if (!atc_btn) return;

            const proDiscountPercentage = parseFloat(priceElem.dataset.proDiscountPercentage) || 0;
            let retail_price = variant.compare_at_price
            let sale_price = variant.price
            let final_price = sale_price;
            let compareAtPrice = variant.compare_at_price;
            let hasSpecialPrice = false;

            // Check if quickshop is open on PDP, if so, don't update the price in the PDP, only update the price in the quickshop modal.
            const productLayout = priceElem?.closest('.product-detail-container')?.attributes['data-layout']?.value;
            if(document.querySelector('.product-detail-container[data-layout="quickshop"]')){
                if(productLayout != 'quickshop'){
                    return;
                }
            }
            
            if (proDiscountPercentage > 0) {
                // for pro pricing  Sale Price -> compare at price, Retail Price -> Actual Price and PRO price  -> Price after discount 
                final_price = sale_price * (1.0 - proDiscountPercentage);

                let saving_amount = sale_price - final_price;
                let saving_percent = saving_amount / sale_price * 100;
                if (retail_price) {
                    saving_amount = retail_price - final_price;
                    saving_percent = saving_amount / retail_price * 100;
                }
                let pro_price_html = `
                <div class="price-card">
                    <div class="price-card-top ${!retail_price ? 'no-retail-price' : ''}">
                        ${retail_price ? ` <div class="price-card-retail">
                                <span class="price-card-label">Retail</span>
                                <span class="price-card-value">${Shopify.formatMoney(retail_price, window.theme.moneyFormat)}</span>
                            </div>`: ''}
                    <div class="price-card-sale">
                        <span class="price-card-label">${retail_price ? 'Sale' : 'Retail'}</span>
                        <span class="price-card-value">${Shopify.formatMoney(sale_price, window.theme.moneyFormat)}</span>
                    </div>
                </div>
                <div class="price-card-pro"> <span class="price-card-final">PRO Price
                </span> ${Shopify.formatMoney(final_price, window.theme.moneyFormat)}</div>
                </div>
                <div class="price-card-saving">
                   <div class="price-card-saving-inner">
                        ${saving_amount > 0 ? `<span class="price-card-save-amount">You save: ${Shopify.formatMoney(saving_amount, window.theme.moneyFormat)}</span>` : ''}
                        <span class="price-divider" aria-hidden="true"></span>
                        ${saving_percent > 0 ? `<span class="price-card-save-percent">${saving_percent.toFixed(0)}% off original retail</span>` : ''}
                   </div>
                </div>
                `
                priceElem.innerHTML = pro_price_html;
                console.log("PRO Price HTML:", pro_price_html);
            } else {
                // for consumer pricing 
                let saving_amount = 0;
                let saving_percent = 0;
                let con_price_html = '<div class="con-price-card">';
                if (retail_price > final_price) {
                    saving_amount = retail_price - final_price; //  final_price -> sale price
                    saving_percent = saving_amount / retail_price * 100;
                    con_price_html += `
                        <span class="con-price-retail">${Shopify.formatMoney(retail_price, window.theme.moneyFormat)}</span>
                    `
                }
                con_price_html += `
                        <span class="con-price-final">${Shopify.formatMoney(final_price, window.theme.moneyFormat)}</span>
                    </div>
                    `
                if (saving_amount > 0) {
                    con_price_html += `<div class="price-card-saving">
                        <div class="price-card-saving-inner">
                                ${saving_amount > 0 ? `<span class="price-card-save-amount">You save: ${Shopify.formatMoney(saving_amount, window.theme.moneyFormat)}</span>` : ''}
                                <span class="price-divider" aria-hidden="true"></span>
                                ${saving_percent > 0 ? `<span class="price-card-save-percent">${saving_percent.toFixed(0)}% off original retail</span>` : ''}
                        </div>
                    </div>`}
                priceElem.innerHTML = con_price_html;
                if (hasDiscountLink && discountLink) {
                    priceElem.insertBefore(discountLink, priceElem.querySelector('.price-card-saving') || null);
                }
            }
            // priceElem.innerHTML = main_price_html;
            // atc_btn.innerHTML = atc_btn_price_html; Delete 7/2026 if still unused
            let atc_btn_price_html = `<p class="add-to-cart-text">Add to Cart - ${Shopify.formatMoney(final_price, window.theme.moneyFormat)}</p>`;
            sticky_atc.innerHTML = atc_btn_price_html;

        });
    },

    initReviews: function () {
        ratingSnippet("ruk_rating_snippet", {
            store: "bellami-hair",
            mode: "default",
            color: "#101010",
            linebreak: false,
            text: "",
            singularText: "",
            lang: "en",
            usePolaris: true,
            showEmptyStars: false,
        });
    },

    productCore: function () {
        var self = this;
        self.productQuantity();
        if (self.productCrossSell.length > 0) {
            self.enableProductCrossSell();
        }

        // A Nosto-backed cross-sell tab has produced cards. This either fills an
        // empty tab or replaces the product-list cards already sitting in it, so
        // an existing carousel has to be torn down before the swap.
        document.addEventListener('cross-sell:nosto-tab-cards', function (event) {
            var detail = event.detail || {};
            if (!detail.container || !detail.tabId || !detail.cards) return;

            var target = detail.container.querySelector(
                '.tab-carousel[data-tab-id="' + detail.tabId + '"] .cross-sell-products'
            );
            if (!target) return;

            if ($(target).hasClass('slick-initialized')) {
                $(target).slick('unslick');
            }

            target.innerHTML = '';
            detail.cards.forEach(function (card) {
                target.appendChild(card);
            });
        });

        // Fired once every Nosto-backed tab has settled, so the tabs that changed
        // get slicked (the initial page-load setup ran before Nosto responded).
        document.addEventListener('cross-sell:nosto-loaded', function (event) {
            var container = event.detail && event.detail.container;
            if (!container) return;

            self.productCrossSell = $(container);

            if (self.crossSellInitCarousel) {
                container.querySelectorAll('.tab-carousel').forEach(self.crossSellInitCarousel);
                self.truncateProductTitles();
            } else {
                // No curated tabs existed, so the initial setup was skipped.
                self.enableProductCrossSell();
            }
        });

        self.productCoreComboboxes();
        if (!self.isQuickshopLayout) {
            if (self.enableMiniCore) {
                self.productCoreMini();
            }

            // if (self.isScrollingLayout && !self.isScrollingGrid) {
            //     self.productCoreScrollFixing()
            // }
            self.productCoreScrollFixing()

            self.productCoreSwatchFilter();
        }
    },

    productQuantity: function () {
        var self = this;
        var $input = self.productQty.find('.qty-input[type=number]');
        var qty = $input.data('value');

        var events = {
            'click .product-qty-container .qty-btn': function (e) {
                e.preventDefault();
                var $curr = $(e.currentTarget);
                if ($curr.hasClass('plus')) {
                    $input[0].stepUp()
                } else {
                    $input[0].stepDown();
                }
                $input.attr('value', $input.val())
            }
        }

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    enableProductCrossSell: function () {
        var self = this;
        const crossSellContainer = self.productCrossSell.get()[0];
        const tabTriggers = crossSellContainer.querySelectorAll('.tab-trigger');
        const tabCarousels = crossSellContainer.querySelectorAll('.tab-carousel');
        const navPrevArrow = crossSellContainer.querySelector('.nav-arrow-prev');
        const navNextArrow = crossSellContainer.querySelector('.nav-arrow-next');

        let currentSlider = null;

        // Truncate product titles to 2 lines with ellipsis (fallback for older browsers)
        self.truncateProductTitles();

        // Initialise one tab's carousel. Safe to call again later for a tab that
        // filled in asynchronously (the Nosto tab): an empty container is left
        // alone, and an already-initialised one is skipped
        function initCarousel(carousel) {
            const crossSellProducts = carousel.querySelector('.cross-sell-products');
            if (!crossSellProducts) return;

            // Check number of slides to determine slidesToShow value
            const slideCount = crossSellProducts.querySelectorAll('.product-grid-item-small').length;
            if (!slideCount) return;
            if ($(crossSellProducts).hasClass('slick-initialized')) return;

            $(crossSellProducts).slick({
                arrows: false,
                dots: false,
                infinite: false,
                speed: 600,
                slidesToShow: slideCount === 1 ? 1 : 1.4,
                slidesToScroll: 1,
                centerMode: false,
                variableWidth: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                ]
            });

            // Update arrow states when carousel changes
            $(crossSellProducts).on('afterChange', function (event, slick, currentSlide) {
                if (carousel.classList.contains('active')) {
                    updateArrowStates(slick, currentSlide);
                }
            });

            // Set initial slider if this carousel is active
            if (carousel.classList.contains('active')) {
                currentSlider = $(crossSellProducts).slick('getSlick');
                updateArrowStates(currentSlider, 0);
            }
        }

        tabCarousels.forEach(initCarousel);

        // Exposed so the Nosto tab can be slicked once its cards land, without
        // re-running this whole setup and re-binding every handler.
        self.crossSellInitCarousel = initCarousel;

        function updateArrowStates(slick, currentSlide) {
            if (!slick || !navPrevArrow || !navNextArrow) return;

            // Update prev arrow
            if (currentSlide === 0) {
                navPrevArrow.classList.add('slick-disabled');
            } else {
                navPrevArrow.classList.remove('slick-disabled');
            }

            // Update next arrow
            if (currentSlide >= slick.slideCount - 1) {
                navNextArrow.classList.add('slick-disabled');
            } else {
                navNextArrow.classList.remove('slick-disabled');
            }
        }

        // Handle arrow clicks
        if (navPrevArrow) {
            navPrevArrow.addEventListener('click', function () {
                if (!currentSlider || navPrevArrow.classList.contains('slick-disabled')) return;
                currentSlider.slickPrev();
            });
        }

        if (navNextArrow) {
            navNextArrow.addEventListener('click', function () {
                if (!currentSlider || navNextArrow.classList.contains('slick-disabled')) return;
                currentSlider.slickNext();
            });
        }

        tabTriggers.forEach((tabTrigger) => {
            tabTrigger.addEventListener('click', function (event) {
                const triggeredTabId = event.currentTarget.dataset.tabId;

                tabCarousels.forEach(carousel => carousel.classList.remove('active'));
                tabTriggers.forEach(trigger => trigger.classList.remove('active'));
                crossSellContainer.querySelectorAll(`[data-tab-id=${triggeredTabId}]`).forEach(element => element.classList.add('active'));

                // Update current slider reference and arrow states
                const activeCarousel = crossSellContainer.querySelector('.tab-carousel.active');
                if (activeCarousel) {
                    const activeProducts = activeCarousel.querySelector('.cross-sell-products');
                    if ($(activeProducts).hasClass('slick-initialized')) {
                        currentSlider = $(activeProducts).slick('getSlick');
                        updateArrowStates(currentSlider, currentSlider.currentSlide);
                    }
                }
            });
        });
    },

    truncateProductTitles: function () {
        var self = this;
        const productTitles = self.productCrossSell.find('.product-name');
        const productTypes = self.productCrossSell.find('.product-type');

        // Truncate product names to 1 line
        productTitles.each(function () {
            const element = $(this).get(0);
            const computedStyle = window.getComputedStyle(element);
            const lineHeight = parseFloat(computedStyle.lineHeight);
            const maxHeight = lineHeight * 1; // 1 line

            // Check if browser doesn't support -webkit-line-clamp properly
            if (element.scrollHeight > maxHeight + 2) { // +2 for tolerance
                const originalText = element.textContent;
                let truncatedText = originalText;

                // Binary search for the right length
                let start = 0;
                let end = originalText.length;

                while (start < end) {
                    const mid = Math.floor((start + end + 1) / 2);
                    element.textContent = originalText.substring(0, mid) + '...';

                    if (element.scrollHeight <= maxHeight + 2) {
                        start = mid;
                    } else {
                        end = mid - 1;
                    }
                }

                element.textContent = originalText.substring(0, start) + '...';
                element.setAttribute('title', originalText); // Add tooltip
            }
        });

        // Truncate product types to 1 line
        productTypes.each(function () {
            const element = $(this).get(0);
            const computedStyle = window.getComputedStyle(element);
            const lineHeight = parseFloat(computedStyle.lineHeight);
            const maxHeight = lineHeight * 1; // 1 line

            // Check if browser doesn't support -webkit-line-clamp properly
            if (element.scrollHeight > maxHeight + 2) { // +2 for tolerance
                const originalText = element.textContent;
                let truncatedText = originalText;

                // Binary search for the right length
                let start = 0;
                let end = originalText.length;

                while (start < end) {
                    const mid = Math.floor((start + end + 1) / 2);
                    element.textContent = originalText.substring(0, mid) + '...';

                    if (element.scrollHeight <= maxHeight + 2) {
                        start = mid;
                    } else {
                        end = mid - 1;
                    }
                }

                element.textContent = originalText.substring(0, start) + '...';
                element.setAttribute('title', originalText); // Add tooltip
            }
        });
    },

    productCoreScrollFixing: function () {
        var self = this;
        var init = function ($elm) {
            $elm.scrollToFixed({
                zIndex: 2,
                removeOffsets: true,
                dontSetWidth: false,
                marginTop: function () {
                    return $('header.site-header').outerHeight() + 50;
                },
                limit: function () {
                    var limit = $('.scrolling-fix-stopper').offset().top - $(this).height();
                    return limit;
                }
            });
        }

        // Modified scroll to fix for fixing the product media block on desktop
        self.$scrollFixingCore = self.$media.find('.product-media-inner');

        // Not available on Mobile.
        ORW.utilities.mediaCheck(function () {
            if (self.$media.find('.product-media-inner').outerHeight() > $('.product-core-inner').outerHeight()) return;
            init(self.$scrollFixingCore);
        }, function () {
            self.$scrollFixingCore.trigger('detach.ScrollToFixed');
        });
    },

    productCoreMini: function () {
        var self = this;
        var init = function ($elm) {
            console.log('init minicore');
            $elm.scrollToFixed({
                zIndex: 2,
                removeOffsets: true,
                dontSetWidth: true,
                triggerAtBottom: true,
                marginTop: function () {
                    return $(this).height() * (-1);
                },
                fixed: function () {
                    $(this).addClass('fixed-core fadeInUp animated');
                },
                unfixed: function () {
                    $(this).removeClass('fixed-core fadeInUp animated');
                }
            });
        }
        self.$miniCore = self.$productCore.find('.block-core');
        // Under scrolling layout, miniCore will only available on Small screen.
        ORW.utilities.mediaCheck(function () {
            self.$miniCore.trigger('detach.ScrollToFixed');
            if (!self.isScrollingLayout || self.isScrollingGrid) {
                init(self.$miniCore);
            }
        }, function () {
            self.$miniCore.trigger('detach.ScrollToFixed');
            init(self.$miniCore);
        });
    },

    productCoreComboboxes: function () {
        const self = this;

        const comboboxContainers = self.el.querySelectorAll('.combobox');

        if (!comboboxContainers) return;

        // Function to close all comboboxes
        const closeAllComboboxes = () => {
            comboboxContainers.forEach(container => {
                container.classList.remove('active');
                const trigger = container.querySelector('.combobox-trigger');
                if (trigger) {
                    trigger.setAttribute('aria-expanded', 'false');
                }
            });
        };

        // Handle clicks outside combobox
        const handleClickOutside = (event) => {
            let clickedInsideCombobox = false;

            comboboxContainers.forEach(container => {
                if (container.contains(event.target)) {
                    clickedInsideCombobox = true;
                }
            });

            if (!clickedInsideCombobox) {
                closeAllComboboxes();
            }
        };

        // Add document click listener for both desktop and mobile
        document.addEventListener('click', handleClickOutside);

        // Store reference for cleanup
        self.comboboxClickOutsideHandler = handleClickOutside;

        comboboxContainers.forEach(comboboxContainer => {
            const comboboxTrigger = comboboxContainer.querySelector('.combobox-trigger');
            const comboboxDropdown = comboboxContainer.querySelector('.combobox-dropdown');
            const comboboxTriggerSelectedValue = comboboxTrigger.querySelector('.trigger-selected-value');

            const toggleCombobox = (event) => {
                const isExpanded = comboboxTrigger.getAttribute('aria-expanded') === 'true';

                event.preventDefault();
                event.stopPropagation(); // Prevent document click handler from firing immediately

                comboboxContainer.classList.toggle('active');
                comboboxTrigger.setAttribute('aria-expanded', !isExpanded);

                // Close all other comboboxes
                comboboxContainers.forEach(otherContainer => {
                    if (otherContainer !== comboboxContainer) {
                        const otherTrigger = otherContainer.querySelector('.combobox-trigger');
                        otherContainer.classList.remove('active');
                        otherTrigger.setAttribute('aria-expanded', 'false');
                    }
                });

                const currentTarget = event?.target || null;
                if (currentTarget) {
                    setTimeout(() => {
                        const siteHeader = document.querySelector('header.site-header');
                        const isMobile = self.isMobile();

                        // If on desktop and header exists, calculate scroll position accounting for sticky header
                        if (!isMobile && siteHeader) {
                            const headerHeight = siteHeader.offsetHeight;
                            const offset = 20; // Additional buffer space below header
                            const elementRect = currentTarget.getBoundingClientRect();
                            const absoluteElementTop = elementRect.top + window.pageYOffset;
                            const scrollPosition = absoluteElementTop - headerHeight - offset;

                            window.scrollTo({
                                top: scrollPosition,
                                behavior: 'auto'
                            });
                        } else {
                            // On mobile or no header, use default scroll behavior
                            currentTarget.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'auto' });
                        }
                    }, 100);
                }
            }

            comboboxDropdown.querySelectorAll('.combobox-item').forEach(item => {
                item.addEventListener('click', (event) => {
                    event.stopPropagation(); // Prevent document click handler from firing
                    if (item.dataset.value) {
                        comboboxTriggerSelectedValue.textContent = item.dataset.value;

                        comboboxContainer.classList.remove('active');
                        comboboxTrigger.setAttribute('aria-expanded', 'false');
                    }
                })
            })

            comboboxTrigger.addEventListener('click', toggleCombobox);
        });
    },

    productCoreSwatchFilter: function () {
        const self = this;
        const categoriesContainer = self.el.querySelector('.shade-categories');
        const categoriesList = categoriesContainer ? categoriesContainer.querySelector('.category-list') : null;
        const categoriesNavLeftButton = categoriesContainer ? categoriesContainer.querySelector('.nav-arrow-left') : null;
        const categoriesNavRightButton = categoriesContainer ? categoriesContainer.querySelector('.nav-arrow-right') : null;
        const categories = self.el.querySelectorAll(`.shade-categories .shade-category`)
        const imageSwatches = self.el.querySelectorAll(`.swatches.linked .swatch`)
        const comboboxItems = self.el.querySelectorAll(`.shade-combobox .combobox-dropdown .shade-item`);
        const previouslySelectedCategory = sessionStorage.getItem("selectedCategory");
        const previouslySelectedLinkedCollection = sessionStorage.getItem("selectedLinkedCollection");
        const categoriesIsOverflowing = categoriesList ? categoriesList.scrollWidth > categoriesList.clientWidth : false;

        const setShadeCategory = (category) => {
            const swatchMatch = self.el.querySelector(`.shade-categories .shade-category[data-category="${category}"]`)
            if (!swatchMatch) return;
            categories.forEach(category => category.classList.remove('active'));

            swatchMatch.classList.add('active');

            imageSwatches.forEach(swatch => {
                const swatchCategory = swatch.dataset.category;
                swatch.style.display = swatchCategory === category || category === 'all' ? 'block' : 'none';
            });

            comboboxItems.forEach(swatch => {
                const swatchCategory = swatch.dataset.category;
                swatch.style.display = swatchCategory === category || category === 'all' ? 'block' : 'none';
            });

            if (self.linkedCollectionData !== null) {
                sessionStorage.setItem("selectedCategory", category);
                sessionStorage.setItem("selectedLinkedCollection", self.linkedCollectionData.handle);
            }
        }

        const scrollCategories = (direction) => {
            const containerWidth = categoriesContainer.offsetWidth;
            const scrollAmount = containerWidth * 0.5;
            const currentScroll = categoriesList.scrollLeft;

            let newScroll;
            if (direction === 'left') {
                newScroll = Math.max(0, currentScroll - scrollAmount);
            } else if (direction === 'right') {
                newScroll = Math.min(categoriesList.scrollWidth - containerWidth, currentScroll + scrollAmount);
            }

            categoriesList.scrollTo({
                left: newScroll,
                behavior: 'smooth'
            });
        }

        // Set up shade category scroll
        if (categoriesIsOverflowing) {
            categoriesContainer.classList.add('is-overflowing');

            categoriesList.addEventListener('scroll', (event) => {
                if (categoriesList.scrollLeft <= 30) {
                    categoriesContainer.classList.add('scrolled-to-left');
                } else {
                    categoriesContainer.classList.remove('scrolled-to-left');
                }

                if (categoriesList.scrollLeft + categoriesList.offsetWidth >= categoriesList.scrollWidth - 30) {
                    categoriesContainer.classList.add('scrolled-to-right');
                } else {
                    categoriesContainer.classList.remove('scrolled-to-right');
                }
            });

            categoriesNavLeftButton.addEventListener('click', (event) => {
                event.preventDefault();
                scrollCategories('left');
            });

            categoriesNavRightButton.addEventListener('click', (event) => {
                event.preventDefault();
                scrollCategories('right');
            });
        }

        if (previouslySelectedCategory && (previouslySelectedLinkedCollection === self.linkedCollectionData.handle)) {
            const storedMatch = self.el.querySelector(`.shade-categories .shade-category[data-category="${previouslySelectedCategory}"]`);
            setShadeCategory(storedMatch ? previouslySelectedCategory : 'all');
        }

        var events = {
            'click .shade-categories .shade-category:not(.active)': function (e) {
                setShadeCategory(e.currentTarget.dataset.category);
            }
        }

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    productCoreSwatchSlider: function () {
        const self = this;
        const swatchContainer = self.el.querySelector('.image-swatches');
        const swatchSliderConfig = {
            swatchSize: self.isMobile() ? 32 : 35,
            gapSize: 8,
            swatchesToScroll: 4
        };

        if (!swatchContainer) return;

        const swatchPrevButton = self.el.querySelector('.swatch-prev');
        const swatchNextButton = self.el.querySelector('.swatch-next');

        swatchPrevButton.addEventListener('click', (event) => {
            event.preventDefault();
            swatchContainer.scrollBy({
                left: -(swatchSliderConfig.swatchSize + swatchSliderConfig.gapSize) * swatchSliderConfig.swatchesToScroll,
                behavior: 'smooth'
            })
        })

        swatchNextButton.addEventListener('click', (event) => {
            event.preventDefault();
            swatchContainer.scrollBy({
                left: (swatchSliderConfig.swatchSize + swatchSliderConfig.gapSize) * swatchSliderConfig.swatchesToScroll,
                behavior: 'smooth'
            })
        })
    },

    shippingCountdownBanner: function () {
        const self = this;
        const shippingCountdownBanner = self.$shippingCountdownBanner[0];
        const bannerTimeRemaining = shippingCountdownBanner.querySelector('.remaining-time');
        const bannerShippingType = shippingCountdownBanner.querySelector('.shipping-type');

        // Calculate seconds remaining until next 2 PM Pacific Time
        function calcRemainingTime() {
            const now = new Date();
            const pacificParts = new Intl.DateTimeFormat('en-US', {
                timeZone: 'America/Los_Angeles',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                weekday: 'short',
                hour12: false
            }).formatToParts(now);

            const currentHour = Number(pacificParts.find(p => p.type === 'hour').value);
            const currentMinute = Number(pacificParts.find(p => p.type === 'minute').value);
            const currentSecond = Number(pacificParts.find(p => p.type === 'second').value);
            const currentDayStr = pacificParts.find(p => p.type === 'weekday').value;
            const dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
            const currentDay = dayMap[currentDayStr];

            let hoursUntilTarget = 0;
            let minutesUntilTarget = 0;
            let secondsUntilTarget = 0;

            const targetHour = 14; // 2 PM
            if (currentHour >= targetHour) {
                hoursUntilTarget = targetHour + (23 - currentHour);
                if (currentDay === 5) { // Friday
                    hoursUntilTarget += 48;
                } else if (currentDay === 6) { // Saturday
                    hoursUntilTarget += 24;
                }
            } else {
                hoursUntilTarget = targetHour - currentHour;
                if (currentDay === 0) { // Sunday
                    hoursUntilTarget += 24;
                } else if (currentDay === 6) { // Saturday
                    hoursUntilTarget += 48;
                }
            }
            const totalSeconds = (hoursUntilTarget * 60 * 60) + ((minutesUntilTarget - currentMinute) * 60) + (secondsUntilTarget - currentSecond);
            return totalSeconds;
        }

        // Get location data and construct shipping message
        $.getJSON('https://jsonip.com/?callback=?').done(function (data) {
            $.getJSON("https://get.geojs.io/v1/ip/geo/" + data.ip + ".json", function (data) {
                const { region, country_code3: countryCode, city } = data;
                const isUSA = countryCode === "USA";
                const hasCity = city !== "";
                const hasRegion = region !== "";
                const messages = {
                    standard: "WORLDWIDE SHIPPING",
                    local: "FREE 2-DAY SHIPPING",
                    international: "FREE SHIPPING"
                };
                let shippingType = messages.standard;

                if (region === "Alaska" || region === "Hawaii") {
                    messages.local = "FREE 3-DAY SHIPPING"
                }

                if (isUSA) {
                    if (hasCity) {
                        shippingType = messages.local;
                    } else if (hasRegion) {
                        shippingType = messages.local;
                    }
                } else {
                    if (hasCity) {
                        shippingType = messages.international;
                    } else if (hasRegion) {
                        shippingType = messages.international;
                    }
                };

                bannerShippingType.textContent = shippingType;
            });
        });

        const secondsRemaining = calcRemainingTime();
        const futureTimestamp = Date.now() + (secondsRemaining * 1000);
        const futureDate = new Date(futureTimestamp);

        if (bannerTimeRemaining) {
            const setTimeString = () => {
                const now = new Date();
                const timeDiff = futureDate - now;

                if (timeDiff <= 0) {
                    bannerTimeRemaining.textContent = "00:00";
                    return;
                }

                const hours = Math.floor(timeDiff / (1000 * 60 * 60));
                const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
                const formattedTime = `${String(hours)} Hours : ${String(minutes)} Minutes`;

                bannerTimeRemaining.textContent = formattedTime;
            };

            setTimeString();
            setInterval(() => { setTimeString(); }, 1000)
        }
    },

    social: function () {
        var self = this;
        var events = {
            'click .share-title': function (e) {
                self.$socialIcons.toggleClass('active');
            },
        };

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    zoom: function () {
        var self = this;
        OneZoom.init({
            el: self.$media,
            mainImage: self.$mainImage,
            thumbImage: self.$thumbImage
        });
    },

    video: function () {
        var self = this;
        var $videos = self.$media.find('.video-wrapper');
        OneVideo.init({
            el: $videos,
            isResponsive: false,
            bgVideo: true,
            autoplay: false
        });
    },

    accordionsAndTabs: function () {
        var self = this;
        OneTabSystem.init({
            el: self.$content
        });
    },

    sizeChart: function () {
        var self = this;
        var sizeChartModal = $('#SizeChartModal')[0];
        if (!sizeChartModal) return;
        var sizeChartHtml = sizeChartModal.outerHTML;
        $('#SizeChartModal').remove();
        var drawerCtl = OneDrawer.init({
            drawerContent: sizeChartHtml,
            drawerModalId: 'SizeChartDrawerModal',
            triggerEvent: 'click',
            triggerElem: '.size-chart-trigger',
            initCallback: function () {
                OneTabSystem.init({
                    el: $('#SizeChartModal')
                });
            },
            openCallback: function () { },
            closeCallback: function () { },
            events: {}
        });
    },

    recentlyViewed: function () {

        let self = this;

        OneRecentlyViewed.init({
            el: self.$recentlyViewed
        });
    },

    initEducationForm: function () {
        var self = this;

        var $triggerBtn = self.$content.find('.education-ticket-trigger');
        if (!$triggerBtn.length) {
            console.log('Education trigger button not found');
            return;
        }

        var $popupContainer = self.$content.find('.education-form-popup-container');
        if (!$popupContainer.length) {
            console.error('Education form: Popup container not found');
            return;
        }

        var popupHtml = $popupContainer.html();

        // Initialize OneDrawer for the popup
        var drawerCtl = OneDrawer.init({
            drawerContent: popupHtml,
            drawerModalId: 'EducationFormDrawerModal',
            triggerEvent: 'click',
            triggerElem: '.education-ticket-trigger',
            initCallback: function () {
                self.setupEducationForm(this);
            },
            openCallback: function () {
                console.log('OneDrawer opened');
            },
            closeCallback: function () {
                var $form = this.$drawer.find('#EducationAddToCartForm');
                if ($form.length) {
                    $form[0].reset();
                    self.updateAttendeeFields(1, this.$drawer.find('#attendees-container'));
                }
            },
            events: {}
        });
    },

    setupEducationForm: function (drawerCtl) {
        var self = this;
        var $drawer = drawerCtl.$drawer;

        var $form = $drawer.find('#EducationAddToCartForm');
        var $quantitySelect = $drawer.find('#ticket-quantity');
        var $attendeesContainer = $drawer.find('#attendees-container');
        var $submitBtn = $drawer.find('#EducationAddToCart');
        var $errors = $drawer.find('#education-form-errors');


        if (!$form.length) {
            return;
        }

        // Initialize with 1 attendee
        self.updateAttendeeFields(1, $attendeesContainer);

        // Handle quantity change
        $quantitySelect.on('change', function () {
            var quantity = parseInt($(this).val());
            self.updateAttendeeFields(quantity, $attendeesContainer);
        });

        // Handle remove attendee buttons
        $attendeesContainer.on('click', '.attendee-remove-btn', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var attendeeIndex = parseInt($(this).attr('data-attendee-index'));
            self.removeAttendee(attendeeIndex, $attendeesContainer);
        });

        var formElement = $form[0];
        formElement.addEventListener('submit', function (e) {
            console.log('Form submit event triggered');
            e.preventDefault();
            e.stopPropagation();
            self.submitEducationForm($form, $errors, drawerCtl);
            return false;
        });

        $submitBtn.on('click', function (e) {
            console.log('Submit button clicked');
            e.preventDefault();
            e.stopPropagation();
            self.submitEducationForm($form, $errors, drawerCtl);
            return false;
        });
    },

    updateAttendeeFields: function (quantity, $container) {
        var self = this;

        if (!$container) {
            $container = $(self.el.querySelector('#attendees-container'));
        }

        if (!$container.length) return;

        var currentCount = $container.find('.attendee-fields').length;

        // Remove extra fields
        if (currentCount > quantity) {
            $container.find('.attendee-fields').slice(quantity).remove();
        }

        // Add missing fields
        for (var i = currentCount + 1; i <= quantity; i++) {
            var attendeeHtml = self.generateAttendeeFields(i);
            $container.append(attendeeHtml);
        }

        // Update attendee headings and renumber all fields
        self.renumberAttendeeFields($container);

        // Update remove button visibility (hide if only 1 attendee)
        self.updateRemoveButtonVisibility($container);
    },

    renumberAttendeeFields: function ($container) {
        var self = this;

        $container.find('.attendee-fields').each(function (index) {
            var newIndex = index + 1;
            var $attendeeFields = $(this);

            $attendeeFields.attr('data-attendee-index', newIndex);
            $attendeeFields.find('.attendee-heading').text('Attendee ' + newIndex + ' Information');
            $attendeeFields.find('.attendee-remove-btn').attr('data-attendee-index', newIndex).attr('aria-label', 'Remove attendee ' + newIndex);

            // Update all input fields
            var $firstName = $attendeeFields.find('.first-name-form-field input[type="text"]');
            if ($firstName.length) {
                $firstName.attr('id', 'attendee_' + newIndex + '_first_name').attr('name', 'attendee_' + newIndex + '_first_name');
                $attendeeFields.find('.first-name-form-field label').attr('for', 'attendee_' + newIndex + '_first_name');
            }

            var $lastName = $attendeeFields.find('.last-name-form-field input[type="text"]');
            if ($lastName.length) {
                $lastName.attr('id', 'attendee_' + newIndex + '_last_name').attr('name', 'attendee_' + newIndex + '_last_name');
                $attendeeFields.find('.last-name-form-field label').attr('for', 'attendee_' + newIndex + '_last_name');
            }

            var $email = $attendeeFields.find('.email-form-field input[type="email"]');
            if ($email.length) {
                $email.attr('id', 'attendee_' + newIndex + '_email').attr('name', 'attendee_' + newIndex + '_email');
                $attendeeFields.find('.email-form-field label').attr('for', 'attendee_' + newIndex + '_email');
            }

            var $phone = $attendeeFields.find('.phone-number-form-field input[type="tel"]');
            if ($phone.length) {
                $phone.attr('id', 'attendee_' + newIndex + '_phone').attr('name', 'attendee_' + newIndex + '_phone');
                $attendeeFields.find('.phone-number-form-field label').attr('for', 'attendee_' + newIndex + '_phone');
            }

            var $salonName = $attendeeFields.find('.salon-name-form-field input[type="text"]');
            if ($salonName.length) {
                $salonName.attr('id', 'attendee_' + newIndex + '_salon_name').attr('name', 'attendee_' + newIndex + '_salon_name');
                $attendeeFields.find('.salon-name-form-field label').attr('for', 'attendee_' + newIndex + '_salon_name');
            }

            var $optIn = $attendeeFields.find('.marketing-form-field input[type="checkbox"]');
            if ($optIn.length) {
                $optIn.attr('id', 'attendee_' + newIndex + '_opt_in_marketing').attr('name', 'attendee_' + newIndex + '_opt_in_marketing');
            }

            // Hidden property inputs
            $attendeeFields.find('input[id^="prop_attendee_"]').each(function () {
                var $hiddenInput = $(this);
                var oldId = $hiddenInput.attr('id');
                var fieldType = '';

                if (oldId.indexOf('_first_name') !== -1) {
                    fieldType = '_first_name';
                    $hiddenInput.attr('id', 'prop_attendee_' + newIndex + '_first_name').attr('name', 'properties[Attendee First Name]');
                } else if (oldId.indexOf('_last_name') !== -1) {
                    fieldType = '_last_name';
                    $hiddenInput.attr('id', 'prop_attendee_' + newIndex + '_last_name').attr('name', 'properties[Attendee Last Name]');
                } else if (oldId.indexOf('_email') !== -1) {
                    fieldType = '_email';
                    $hiddenInput.attr('id', 'prop_attendee_' + newIndex + '_email').attr('name', 'properties[Attendee Email]');
                } else if (oldId.indexOf('_salon_name') !== -1) {
                    fieldType = '_salon_name';
                    $hiddenInput.attr('id', 'prop_attendee_' + newIndex + '_salon_name').attr('name', 'properties[Attendee Salon Name]');
                } else if (oldId.indexOf('_phone') !== -1) {
                    fieldType = '_phone';
                    $hiddenInput.attr('id', 'prop_attendee_' + newIndex + '_phone').attr('name', 'properties[Attendee Phone Number]');
                } else if (oldId.indexOf('_seat_type') !== -1) {
                    fieldType = '_seat_type';
                    $hiddenInput.attr('id', 'prop_attendee_' + newIndex + '_seat_type').attr('name', 'properties[Seat Type]');
                } else if (oldId.indexOf('_opt_in_marketing') !== -1) {
                    fieldType = '_opt_in_marketing';
                    $hiddenInput.attr('id', 'prop_attendee_' + newIndex + '_opt_in_marketing').attr('name', 'properties[Opt-in Marketing]');
                }
            });
        });
    },

    updateRemoveButtonVisibility: function ($container) {
        var count = $container.find('.attendee-fields').length;
        $container.find('.attendee-remove-btn').toggle(count > 1);
    },

    removeAttendee: function (attendeeIndex, $container) {
        var self = this;

        // Find and remove the attendee field
        var $attendeeField = $container.find('.attendee-fields[data-attendee-index="' + attendeeIndex + '"]');
        if (!$attendeeField.length) return;

        $attendeeField.remove();

        // Renumber remaining attendees
        self.renumberAttendeeFields($container);

        // Update dropdown to reflect new count
        var newCount = $container.find('.attendee-fields').length;
        var $quantitySelect = $container.closest('form').find('#ticket-quantity');
        if ($quantitySelect.length) {
            $quantitySelect.val(newCount);
        }

        // Update remove button visibility
        self.updateRemoveButtonVisibility($container);
    },

    generateAttendeeFields: function (index) {
        return `
            <div class="attendee-fields" data-attendee-index="${index}">
                <div class="attendee-heading-wrapper">
                    <h3 class="attendee-heading">Attendee ${index} Information</h3>
                    <button type="button" class="attendee-remove-btn" data-attendee-index="${index}" aria-label="Remove attendee ${index}">Remove</button>
                </div>
                <div class="form-field first-name-form-field">
                    <label for="attendee_${index}_first_name">First Name <span class="required">*</span></label>
                    <input type="text" id="attendee_${index}_first_name" name="attendee_${index}_first_name" placeholder="First Name*" required>
                </div>
                <div class="form-field last-name-form-field">
                    <label for="attendee_${index}_last_name">Last Name <span class="required">*</span></label>
                    <input type="text" id="attendee_${index}_last_name" name="attendee_${index}_last_name" placeholder="Last Name*" required>
                </div>
                <div class="form-field email-form-field">
                    <label for="attendee_${index}_email">Email <span class="required">*</span></label>
                    <input type="email" id="attendee_${index}_email" name="attendee_${index}_email" placeholder="Email*" required>
                </div>
                <div class="form-field phone-number-form-field">
                    <label for="attendee_${index}_phone">Phone Number</label>
                    <input type="tel" id="attendee_${index}_phone" name="attendee_${index}_phone" placeholder="Phone Number*" required>
                </div>
                <div class="form-field salon-name-form-field">
                    <label for="attendee_${index}_salon_name">Salon Name</label>
                    <input type="text" id="attendee_${index}_salon_name" name="attendee_${index}_salon_name" placeholder="Salon Name">
                </div>
                <div class="form-field marketing-form-field">
                    <label>
                        <input type="checkbox" id="attendee_${index}_opt_in_marketing" name="attendee_${index}_opt_in_marketing" value="yes">
                        <span>Opt-in to Marketing Communications</span>
                    </label>
                </div>
                <input type="hidden" name="properties[Attendee First Name]" id="prop_attendee_${index}_first_name" value="">
                <input type="hidden" name="properties[Attendee Last Name]" id="prop_attendee_${index}_last_name" value="">
                <input type="hidden" name="properties[Attendee Email]" id="prop_attendee_${index}_email" value="">
                <input type="hidden" name="properties[Attendee Salon Name]" id="prop_attendee_${index}_salon_name" value="">
                <input type="hidden" name="properties[Attendee Phone Number]" id="prop_attendee_${index}_phone" value="">
                <input type="hidden" name="properties[Seat Type]" id="prop_attendee_${index}_seat_type" value="">
                <input type="hidden" name="properties[Opt-in Marketing]" id="prop_attendee_${index}_opt_in_marketing" value="">
            </div>
        `;
    },

    submitEducationForm: function ($form, $errors, drawerCtl) {
        var self = this;

        // Clear previous errors
        $errors.attr('hidden', true).text('');

        // Validate form
        if (!$form[0].checkValidity()) {
            console.log('Form validation failed');
            $form[0].reportValidity();
            return;
        }

        // Get form data
        var formData = new FormData($form[0]);
        var quantity = parseInt(formData.get('ticket_quantity') || 1);
        var variantId = parseInt(formData.get('id'));


        // // Log all form data entries
        // console.log('All FormData entries:');
        // var allFormEntries = [];
        // for (var pair of formData.entries()) {
        //     console.log('  ' + pair[0] + ': ' + pair[1]);
        //     allFormEntries.push({name: pair[0], value: pair[1]});
        // }
        // console.log('All entries array:', allFormEntries);

        if (!variantId) {
            console.error('Variant ID not found');
            return;
        }

        // Get other hidden properties from form (conversion_rate, pre_order, final_sale)
        var conversionRate = formData.get('properties[_conversion_rate]');
        var preOrderInput = $form.find('input[name*="pre_order"]');
        var finalSaleInput = $form.find('input[name*="final_sale"]');

        // console.log('Additional properties:', {
        //     conversionRate: conversionRate,
        //     preOrderInput: preOrderInput.length,
        //     finalSaleInput: finalSaleInput.length
        // });

        // Build cart items with properties
        var items = [];

        // Multiple tickets - create separate items for each attendee

        // get the kit id 
        var educationKitVariantId = $form.data('edu-kit-variant-id') || null;
        for (var i = 1; i <= quantity; i++) {
            var properties = {};

            // Collect attendee properties
            var firstName = formData.get(`attendee_${i}_first_name`);
            var lastName = formData.get(`attendee_${i}_last_name`);
            var email = formData.get(`attendee_${i}_email`);
            var salonName = formData.get(`attendee_${i}_salon_name`);
            var phone = formData.get(`attendee_${i}_phone`);
            var seatType = formData.get(`attendee_${i}_seat_type`);
            var optInMarketing = formData.get(`attendee_${i}_opt_in_marketing`);

            // Also try getting checkbox value directly from DOM
            var optInCheckbox = $form.find(`#attendee_${i}_opt_in_marketing`);
            if (optInCheckbox.length && optInCheckbox.is(':checked')) {
                optInMarketing = optInCheckbox.val();
            }

            // console.log(`Attendee ${i} raw values:`, {
            //     firstName: firstName,
            //     lastName: lastName,
            //     email: email,
            //     salonName: salonName,
            //     phone: phone,
            //     seatType: seatType,
            //     optInMarketing: optInMarketing
            // });

            if (firstName) properties['Attendee First Name'] = firstName;
            if (lastName) properties['Attendee Last Name'] = lastName;
            if (email) properties['Attendee Email'] = email;
            if (salonName) properties['Attendee Salon Name'] = salonName;
            if (phone) properties['Attendee Phone Number'] = phone;
            if (seatType) properties['Seat Type'] = seatType;
            if (optInMarketing) properties['Opt-in Marketing'] = optInMarketing;

            if (conversionRate) properties['_conversion_rate'] = conversionRate;

            if (preOrderInput.length) {
                var preOrderName = preOrderInput.attr('name').match(/properties\[(.*?)\]/);
                if (preOrderName && preOrderName[1]) {
                    properties[preOrderName[1]] = preOrderInput.val();
                }
            }

            if (finalSaleInput.length) {
                var finalSaleName = finalSaleInput.attr('name').match(/properties\[(.*?)\]/);
                if (finalSaleName && finalSaleName[1]) {
                    properties[finalSaleName[1]] = finalSaleInput.val();
                }
            }

            // console.log(`Attendee ${i} properties object:`, properties);
            // create unique ID for education class
            const educationLinkId = crypto.randomUUID();
            properties['_education_link_id'] = educationLinkId;
            items.push({
                id: variantId,
                quantity: 1,
                properties: properties
            });
            if (educationKitVariantId) {
                items.push({
                    id: educationKitVariantId,
                    quantity: 1,
                    properties: {
                        '_linked_education': variantId,
                        '_education_link_id': educationLinkId,
                        '_EDU_KIT': 'true'
                    }
                });
            }
        }

        // console.log('\n=== Final Items Array ===');
        // console.log(JSON.stringify(items, null, 2));

        // Disable submit button
        var $submitBtn = $form.find('#EducationAddToCart');
        $submitBtn.prop('disabled', true).find('.add-to-cart-text').text('Adding...');

        // Prepare request payload
        var requestPayload = { items: items };

        // Submit to cart
        // Set flag to prevent SearchSpring tracking loop
        window._preventSearchSpringTracking = true;

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
            },
            body: JSON.stringify(requestPayload)
        })
            .then(response => {
                return response.json();
            })
            .then(response => {

                if (response.status) {
                    // Error
                    console.error('Cart API Error:', response);
                    $errors.removeAttr('hidden').text(response.description || 'Error adding items to cart');
                    $submitBtn.prop('disabled', false).find('.add-to-cart-text').text('Add to Cart');
                } else {
                    // Success
                    // Mark as education batch to prevent tracking loops
                    response.cartEvent = 'educationBatchAdd';
                    response.itemCount = items.length;
                    // Publish cart update event
                    publish(PUB_SUB_EVENTS.cartUpdate, response);
                    drawerCtl.closeDrawer();
                    $form[0].reset();
                    self.updateAttendeeFields(1, $form.find('#attendees-container'));
                }

                // Clear flag after a delay to allow cart update to complete
                setTimeout(() => {
                    window._preventSearchSpringTracking = false;
                }, 2000);
            })
            .catch(error => {
                console.error('Error:', error);
                $errors.removeAttr('hidden').text('An error occurred. Please try again.');
                $submitBtn.prop('disabled', false).find('.add-to-cart-text').text('Add to Cart');
                window._preventSearchSpringTracking = false;
            });
    },

    initPostATCModal: function () {
        const self = this;
        const modal = document.getElementById('PostATCModal');

        if (modal) {
            self.postATCModal = OneDrawer.init({
                drawerElem: '#PostATCModal',
                triggerEvent: 'click',
                initCallback: function () {
                    self.postATCModalSlider();

                    const forms = document.querySelectorAll('.post-atc-product-form');
                    forms.forEach(form => {
                        form.addEventListener('submit', (e) => {
                            e.preventDefault();

                            const formData = new FormData(e.currentTarget);
                            const formJson = {
                                items: [
                                    {
                                        id: Number(formData.get('id')),
                                        quantity: Number(formData.get('quantity'))
                                    }
                                ]
                            }
                            const config = {
                                method: 'POST',
                                credentials: "include",
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-Requested-With': 'XMLHttpRequest',
                                    'Accept': 'application/json'
                                },
                                body: JSON.stringify(formJson)
                            };

                            fetch('/cart/add.js', config)
                                .then(response => response.json())
                                .then(response => {
                                    if (response.status) {
                                        publish(PUB_SUB_EVENTS.cartError, {
                                            errors: response.errors || response.description,
                                            message: response.message
                                        });
                                    } else {
                                        publish(PUB_SUB_EVENTS.cartUpdate, response);
                                    }
                                });
                        });
                    });
                },
                openCallback: function () { },
                closeCallback: function () {
                    $('header .block-minicart').trigger('click');
                },
                events: {}
            });



            subscribe(
                PUB_SUB_EVENTS.cartUpdate,
                (data) => {
                    if (data.cartEvent === 'pdpAdd') {
                        if (self.postATCModal) {
                            self.postATCModal.openDrawer();
                        }
                    }
                }
            );
        }
    },

    postATCModalSlider: function () {
        const self = this;
        const container = document.querySelector('#PostATCModal .post-atc-products');
        if (!container) return;

        const sliderContainer = container.querySelector('.post-atc-slider-track');
        if (!sliderContainer) return;

        const prevButton = container.querySelector('.slider-prev');
        const nextButton = container.querySelector('.slider-next');

        if (!prevButton || !nextButton) return;

        const getScrollAmount = () => {
            const firstItem = sliderContainer.querySelector('.post-atc-product');
            if (!firstItem) return 200; // Fallback amount

            const itemWidth = firstItem.offsetWidth;
            const style = window.getComputedStyle(sliderContainer);
            const gap = parseFloat(style.gap) || 0;

            return itemWidth + gap;
        };

        prevButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation(); // Prevent drawer close if clicking button
            sliderContainer.scrollBy({
                left: -getScrollAmount(),
                behavior: 'smooth'
            });
        });

        nextButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation(); // Prevent drawer close if clicking button
            sliderContainer.scrollBy({
                left: getScrollAmount(),
                behavior: 'smooth'
            });
        });
    },

    initGatedModal: function () {
        const self = this;
        const gatedProductJsonContainer = self.$el[0].querySelector('.gated-product-json');
        if (!gatedProductJsonContainer) return;

        const gatedProductConfig = JSON.parse(gatedProductJsonContainer.textContent);
        const { isGatedProduct, userCanAccessGatedProduct, modal } = gatedProductConfig;
        const modalContent = `
            <div class="modal-content">
                <button class="drawer-close"><span class="visually-hidden">Close modal</span></button>
                <p class="eyebrow">${modal.eyebrowText}</p>
                <h2 class="heading">${modal.headingText}</h2>
                <a href="${modal.accountRegisterUrl}" class="register-cta">${modal.ctaText}</a>

                <div class="modal-footer">
                    <p class="login-text">${modal.loginText}</p>
                    <a href="${modal.accountLoginUrl}" class="login-cta">Login Here</a>
                </div>
            </div>
        `;

        if (isGatedProduct && userCanAccessGatedProduct) return;

        const GatedModalCtl = OneDrawer.init({
            drawerContent: modalContent,
            drawerModalId: 'ProductGatedModal',
            drawerType: 'modal',
            removeOnDestroy: true,
            initCallback: function () {
            },
            openCallback: function () {
            },
            closeCallback: function () {
            },
        });

        GatedModalCtl.openDrawer();
    },

    destroy: function () {
        var self = this;

        // Clean up product form instance
        if (self.productFormInstance && self.productFormInstance.destroy) {
            self.productFormInstance.destroy();
        }

        // Clean up combobox click outside handler
        if (self.comboboxClickOutsideHandler) {
            document.removeEventListener('click', self.comboboxClickOutsideHandler);
        }

        self.undelegateEvents();
    },

    responsive: function () {
        var self = this;
        ORW.utilities.mediaCheck(function () {
            // Desktop actions
        }, function () {
            // Mobile actions
        })
    },

    isMobile: function () {
        if (ORW.responsive == 'small') {
            return true;
        }
        return false;
    }
});
